export default __webpack_public_path__ + "static/media/icon.c4a72209.svg";